import React from "react";
import "./form.css";

import { Tag, Input, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";

const { confirm } = Modal;

export default class Component extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            inputVisible: false,
            inputValue: "",
            editInputId: -1,
            editInputValue: "",
        };
    }

    showInput = () => {
        this.setState({ inputVisible: true }, () => this.input.focus());
    };

    handleInputChange = (e) => {
        this.setState({ inputValue: e.target.value });
    };

    handleInputConfirm = () => {
        const { inputValue } = this.state;
        //if (inputValue && tags2.indexOf(inputValue) === -1) {
        const value = inputValue.trim();

        if (value) {
            this.setState({
                inputVisible: false,
                inputValue: "",
            });

            this.props.handleSubmit(value, null);
        }
    };

    handleCancel = () => {
        this.setState({
            inputVisible: false,
            inputValue: "",
            editInputId: "",
        });
    };

    handleEditInputChange = (e) => {
        this.setState({ editInputValue: e.target.value });
    };

    handleEditInputConfirm = () => {
        this.setState(({ editInputId, editInputValue }) => {
            const value = editInputValue.trim();
            if (value) {
                this.setState({
                    inputVisible: false,
                    inputValue: "",
                });

                this.props.handleSubmit(value, editInputId);
            }
            this.handleCancel();
        });
    };

    saveInputRef = (input) => {
        this.input = input;
    };

    saveEditInputRef = (input) => {
        this.editInput = input;
    };

    showConfirmation = (e, component) => {
        e.preventDefault();
        const { toggle } = this.props;

        let message = "Do you want to delete the item? It will remain inactive if it's has related data.";
        if (!component.active) {
            message = "Do you want to active the item?";
        }

        confirm({
            icon: <ExclamationCircleOutlined />,
            content: message,
            onOk() {
                toggle(component.id);
            },
            onCancel() {},
        });
    };

    render() {
        const { inputVisible, inputValue, editInputId, editInputValue } = this.state;
        const { components } = this.props;
        return (
            <>
                <b>Components: </b>
                {components.map((tag) => {
                    if (editInputId === tag.id) {
                        return (
                            <Input
                                ref={this.saveEditInputRef}
                                key={tag.id}
                                size="small"
                                className="tag-input"
                                value={editInputValue}
                                onChange={this.handleEditInputChange}
                                onBlur={this.handleCancel}
                                onPressEnter={this.handleEditInputConfirm}
                            />
                        );
                    }

                    const isLongTag = tag.name.length > 20;

                    const tagElem = (
                        <Tag
                            className="edit-tag"
                            key={tag.id}
                            closable={true}
                            closeIcon={tag.active ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                            onClose={(e) => this.showConfirmation(e, tag)}
                            color={tag.active ? "success" : "error"}
                        >
                            <span
                                onDoubleClick={(e) => {
                                    this.setState({ editInputId: tag.id, editInputValue: tag.name }, () => {
                                        this.editInput.focus();
                                    });
                                    e.preventDefault();
                                }}
                            >
                                {isLongTag ? `${tag.name.slice(0, 20)}...` : tag.name}
                            </span>
                        </Tag>
                    );
                    return isLongTag ? (
                        <Tooltip title={tag.name} key={tag.id}>
                            {tagElem}
                        </Tooltip>
                    ) : (
                        tagElem
                    );
                })}
                {inputVisible && (
                    <Input
                        ref={this.saveInputRef}
                        type="text"
                        size="small"
                        className="tag-input"
                        value={inputValue}
                        onChange={this.handleInputChange}
                        onBlur={this.handleCancel}
                        onPressEnter={this.handleInputConfirm}
                    />
                )}
                {!inputVisible && (
                    <Tag className="site-tag-plus" onClick={this.showInput}>
                        <PlusOutlined /> New Component
                    </Tag>
                )}
            </>
        );
    }
}
